module.exports = __webpack_public_path__ + "img/pdi4.fe693f9d.svg";